import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { duration: { type: Number, default: 1000 } };

  connect() {
    this.flash();
  }

  flash() {
    // Add the Tailwind class for green background
    this.element.classList.add("bg-green-300", "transition", "ease-out", "duration-1000");
    
    setTimeout(() => {
      // Remove the green background class after the duration
      this.element.classList.remove("bg-green-300");
    }, this.durationValue);
  }
}
